
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { loadingStates } from 'bundles/discussions/constants';

type PropsFromStores = {
  questionId: string;
  page: number;
  sort: string;
};

type PropsFromCaller = {
  questionId: string;
  page: number;
  sort: string;
};

type PropsToComponent = PropsFromCaller & PropsFromStores;

// @ts-expect-error ts-migrate(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
type Component = (PropsToComponent) => JSX.Element | null;

export const withRepliesData = (component: Component) => {
  return connectToStores<PropsToComponent, PropsFromCaller>(
    component,
    ['ThreadDetailsStore'],
    ({ ThreadDetailsStore }, { questionId, page, sort }) => {
      return {
        replies: ThreadDetailsStore.getReplies(questionId, page, sort) || [],
        pageCount: ThreadDetailsStore.getPageCount(questionId, page, sort),
        savingStates: ThreadDetailsStore.savingStates,
        loadingState:
          ThreadDetailsStore.getAnswerLoadedState({
            questionId,
            page,
            sort,
          }) || loadingStates.LOADING,
        isQuestionLoaded: ThreadDetailsStore.isLoaded({ questionId, page, sort }),
      };
    }
  );
};
